export default __webpack_public_path__ + "static/media/carbonara.36df81db.jpeg";